/**
 * XION Medical product data — Illumination systems
 * Content sourced from xion-medical.com (split from completeProductsData.js).
 */

export const illuminationSystems = {
  id: 'led-illumination-systems',
  name: 'Illumination',
  slug: 'led-illumination-systems',
  category: 'Illumination',
  description: 'The high light intensity, compact design and option for external control make XION light sources suitable for a wide range of endoscopic applications, including video-stroboscopy. Even at full light output, operation is almost silent.',
  overview: 'A choice of adapters guarantees compatibility with different types of fibre-optic light conductors and eases integration into existing equipment environments. The range is completed by XION LED light guide cables and the compact Veezar Illumination Heads IH10 and IH20 for rigid and flexible endoscopes.',
  products: [
    {
      id: 'matrix-led-duo',
      name: 'MATRIX LED duo Light Source',
      slug: 'matrix-led-duo',
      tagline: 'High-intensity, almost-silent LED light source',
      description: 'The MATRIX LED duo is a high-intensity, compact LED light source with two light exits, suitable for a wide range of endoscopic applications including video-stroboscopy. Even at full light output operation is almost silent, and a choice of adapters ensures compatibility with different fibre-optic light conductors.',
      features: [
        'Two light exits',
        'Long-life LEDs — low operating costs',
        'Minimum noise level (<30 dB at 1 m distance)',
        'Manual and automatic control for light intensity',
        'Automatic safety shutdown when the fibre-optic light guide is removed',
        'Suitable for video-stroboscopy and external control',
        'Adapter choice for different fibre-optic light conductors'
      ],
      specifications: {
        technology: 'LED',
        lightExits: '2',
        noise: '<30 dB at 1 m'
      },
      images: ['/products/transparent/csm-matrix-led-duo-01-3ac270249d.png']
    },
    {
      id: 'led-light-guide-cables',
      name: 'LED Light Guide Cables',
      slug: 'led-light-guide-cables',
      tagline: 'Optimised fibre-optic cables for LED light sources',
      description: 'XION fibre-optic cables are produced by a special manufacturing process that enables optimum transmission and excellent resistance to the temperature stresses of high-power light sources and to the demands of machine processing. The fibres used in the LED light guide cables are optimised for the spectrum of LED light sources for a further increase in light yield.',
      features: [
        'Special manufacturing process for optimum light transmission',
        'Excellent resistance to high-power light-source temperatures',
        'Durable under machine reprocessing',
        'Fibres optimised for the LED spectrum — higher light yield',
        'Various diameters and lengths available',
        'Optimum adaptation to the endoscope and application'
      ],
      specifications: {
        type: 'Fibre-optic light guide cable',
        optimisedFor: 'LED light sources',
        options: 'Various diameters & lengths'
      },
      images: ['/products/transparent/lichtleitkabel-web.png']
    },
    {
      id: 'veezar-illumination-head-ih10',
      name: 'Veezar Illumination Head IH10',
      slug: 'veezar-illumination-head-ih10',
      tagline: 'Compact, stroboscopy-ready illumination head',
      description: 'The Veezar Illumination Head IH10 is ideal for routine use with rigid and flexible endoscopes. Thanks to its low weight and extremely compact design, handling of the optics is not impaired. In combination with the Veezar Compact Camera CF20 it can also be used to perform stroboscopic examinations of the human vocal folds.',
      features: [
        'Ready for stroboscopy (with Veezar Compact Camera CF20)',
        'Ideal for routine use with rigid and flexible endoscopes',
        'Low weight and extremely compact design',
        'Rugged metal housing',
        'Wipe-disinfectable'
      ],
      specifications: {
        type: 'Veezar Illumination Head',
        model: 'IH10',
        feature: 'Stroboscopy-ready'
      },
      images: ['/products/transparent/veezar-beleuchtungskopf-ih10-web.png']
    },
    {
      id: 'veezar-illumination-head-ih20',
      name: 'Veezar Illumination Head IH20',
      slug: 'veezar-illumination-head-ih20',
      tagline: 'Fully immersible illumination head for demanding reprocessing',
      description: 'The Veezar Illumination Head IH20 is ideal for routine use with rigid and flexible endoscopes. Its low weight and extremely compact design keep handling of the optics unimpaired, while a rugged metal housing and full immersibility support demanding reprocessing requirements.',
      features: [
        'Ideal for routine use with rigid and flexible endoscopes',
        'Low weight and extremely compact design',
        'Rugged metal housing, wipe-disinfectable',
        'Fully immersible in disinfectant solution',
        'Machine-cleanable in a cleaning and disinfecting device (CDD)',
        'Sterilizable using the low-temperature steam and formaldehyde method (LTSF)'
      ],
      specifications: {
        type: 'Veezar Illumination Head',
        model: 'IH20',
        reprocessing: 'Immersible · CDD · LTSF'
      },
      images: ['/products/transparent/veezar-beleuchtungskopf-ih20-web.png']
    }
  ]
};
